module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/reward_badge_gold-af53e8013b9b34fe184cb974976141d9.svg";